<template>
  <div>
    <div class="top">
      <el-row>
        <el-col>
          <span style="margin-left:10px;margin-right:5px">项目名称:</span>
          <el-select v-model="filter.name" placeholder="请选择" clearable style="width:150px">
            <el-option label="上门送餐" value="上门送餐"></el-option>
            <el-option label="洗衣服" value="洗衣服"></el-option>
            <el-option label="预约挂号" value="预约挂号"></el-option>
            <el-option label="智能设备" value="智能设备"></el-option>
          </el-select>
          <span style="margin-left:20px;margin-right:5px">发生时间:</span>
          <el-date-picker
            v-model="filter.time"
            clearable
            type="date"
          ></el-date-picker>
          <el-button style="margin-left:20px;margin-right:5px" type="primary">导出</el-button>
          <el-button type="primary">查询</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%;margin-top:10px"
      :header-cell-style="headerStyle"
    >
      <el-table-column prop="sort" label="序号" align="center"></el-table-column>
      <el-table-column prop="aa" label="时间" align="center"></el-table-column>
      <el-table-column prop="bb" label="工单编号" width="180" align="center"></el-table-column>
      <el-table-column prop="cc" label="服务名称" align="center"></el-table-column>
      <el-table-column prop="dd" label="项目名称" width="180" align="center"></el-table-column>
      <el-table-column prop="ee" label="项目小类" width="180" align="center"></el-table-column>
      <el-table-column prop="ff" label="项目费用（元）" width="180" align="center"></el-table-column>
      <el-table-column prop="gg" label="收费方式" align="center"></el-table-column>
    </el-table>

    <el-row>
      <el-pagination
        style="text-align: center;margin-top:10px"
        background
        layout="total,prev, pager, next,jumper"
        @current-change="changePage"
        :total="11"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {
        content: "",
        serviceName: "",
        name: "",
        time: ""
      },
      tableData: [],
      tableData1: [
        {
          sort: "1",
          aa: "2019-11-12",
          bb: "Fw201912458695",
          cc: "助餐",
          dd: "上门送餐",
          ee: "一荤一素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "2",
          aa: "2019-11-12",
          bb: "Fw2019452356874",
          cc: "助洁",
          dd: "打扫房间",
          ee: "一间",
          ff: "90",
          gg: "元/次"
        },
        {
          sort: "3",
          aa: "2019-11-12",
          bb: "Fw2019125632542",
          cc: "助餐",
          dd: "上门送餐",
          ee: "二荤二素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "4",
          aa: "2019-11-12",
          bb: "Fw201925684253",
          cc: "助餐",
          dd: "上门送餐",
          ee: "二荤二素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "5",
          aa: "2019-11-12",
          bb: "Fw201952364125",
          cc: "助医",
          dd: "预约挂号",
          ee: "专家号",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "6",
          aa: "2019-11-12",
          bb: "Fw201912563455",
          cc: "助餐",
          dd: "上门送餐",
          ee: "二荤二素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "7",
          aa: "2019-11-12",
          bb: "Fw2019523654125",
          cc: "助餐",
          dd: "上门送餐",
          ee: "二荤二素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "8",
          aa: "2019-11-12",
          bb: "Fw2019521452368",
          cc: "远程看护",
          dd: "智能设备",
          ee: "智能手环",
          ff: "20",
          gg: "元/次"
        },
        {
          sort: "9",
          aa: "2019-11-12",
          bb: "Fw2019521436542",
          cc: "助餐",
          dd: "上门送餐",
          ee: "二荤二素",
          ff: "14",
          gg: "元/次"
        },
        {
          sort: "10",
          aa: "2019-11-12",
          bb: "Fw2019524139687",
          cc: "助洁",
          dd: "洗衣服",
          ee: "10",
          ff: "50",
          gg: "元/次"
        }
      ],
      tableData2: [
        {
          sort: "1",
          aa: "2019-11-12",
          bb: "Fw2019521425638",
          cc: "助洁",
          dd: "洗衣服",
          ee: "10",
          ff: "50",
          gg: "元/次"
        }
      ]
    };
  },
  methods: {
    clearFilter(){
      this. filter={
        content: "",
        serviceName: "",
        name: "",
        time: ""
      }
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F2F2F2;";
      }
    },
    //翻页
    changePage(val) {
      if (val == 1) {
        this.tableData = this.tableData1;
      } else {
        this.tableData = this.tableData2;
      }
    }
  },

  mounted() {
    this.tableData = this.tableData1;
  }
};
</script>
<style lang="scss" scoped>
.top {
  background: #f2f2f2;
  padding: 6px;
}
</style>